import * as Yup from 'yup';
import useTranslationPagoNubeOnboarding from 'domains/PagoNubeOnboarding/useTranslationPagoNubeOnboarding';

const prefixPattern = /^\+\d{1,4}$/;
const phonePattern = /^\d{10}$/;

const useOnboardingValidationSchema = () => {
  const t = useTranslationPagoNubeOnboarding('onboardingValidation');

  return Yup.object().shape({
    firstName: Yup.string().required(t('firstName')).nullable(),
    lastName: Yup.string().required(t('lastName')).nullable(),
    phoneNumber: Yup.string()
      .matches(phonePattern, t('phoneNumberInvalid'))
      .required(t('phoneNumber'))
      .nullable(),
    phoneNumberPrefix: Yup.string()
      .matches(prefixPattern, t('phoneNumberPrefixInvalid'))
      .required(t('phoneNumberPrefix'))
      .nullable(),
    birthDate: Yup.string().required(t('birthDate')),
    storeCategory: Yup.string().required(t('storeCategory')).nullable(),
    street: Yup.string().required(t('street')).nullable(),
    zipCode: Yup.string().required(t('zipCode')).nullable(),
  });
};

export default useOnboardingValidationSchema;
